import createImmutableSelector from 'lib/immutable/selector'
import { ILoginLayout } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getLoginLayout = (state: any): ILoginLayout => state.get('loginLayoutReducer')

export const loginLayoutSelector = createImmutableSelector(getLoginLayout, (loginLayout) => loginLayout)
